"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RechargeOptionInit = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var hsAccount_1 = require("../../model/hsAccount");
var service_1 = require("../../../library/base/service");
var RechargeOptionInit = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RechargeOptionInit, _super);
    function RechargeOptionInit() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '充值页面交易所校验接口';
        _this.code = '105040';
        _this.desc = '充值页面交易所校验接口';
        _this.requestParams = new hsAccount_1.RechargeOptionInitRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return RechargeOptionInit;
}(service_1.BaseService));
exports.RechargeOptionInit = RechargeOptionInit;
//# sourceMappingURL=rechargeOptionInit.js.map